module.exports = __webpack_public_path__ + "media/images/flags/se-f9da2d5ff8845a1e848fb7d09065335a.svg";